import React, { useEffect } from "react";
import Title from "./Components/Title";
import DefaultLayout from "../Containers/Layout/DefaultLayout";

const AlbumListeningEvent = () => {
  var album = "https://streams.radiomast.io/station/0e4a27c6-dea2-416d-8852-9df0d0a8690f/player/widget?t=dark&s=02b2a5fa-50fa-4212-a817-55700343a7f5";
  useEffect(() => {
    var addScript = document.createElement("script");
    addScript.setAttribute(
      "src",
      "//rumbletalk.com/client/?B_aLnmdZ"
    );
    document.body.appendChild(addScript);
  }, []);
  return (
    <div className="page sonos">
      <Title value="Album Listening Event" />
      <DefaultLayout
        disablePlayer
        disableBanner
        disableNavItems
      >
      <main className="event-lander">
        <section className="flex-container">
          <div className="column" id="rumble-container" style={{ height: "0px", width: "0px", marginTop: "150px"}}><div id="rt-2ce7eea6437e4f137a65ba95f2b41672"></div></div>
          <div className="column">
            <iframe title="radiomast-player" src={album} scrolling="no" frameBorder="0" allow="autoplay" style={{ margin: "50% 40%"}}></iframe>
          </div>
        </section>
      </main>
      </DefaultLayout>
    </div>
  );
};

export default AlbumListeningEvent;
